import {React,useEffect} from 'react'
 import './Blog.css'
 import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
 import frontEnd from './assets/front-end.png'
 import backEnd from './assets/back-end.png'
 import Ai from './assets/AI.jpg'
 import full from './assets/fullstackdev.png'
 import Footer from './Footer'
 import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
 import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
 import DataScience from './assets/Data-Scientist.png'
 import DataAnal from './assets/Data-Aanalyst.jpeg'
 import BloackChain from './assets/blockchain.jpg'
 import network from './assets/network.jfif'
 import Database from './assets/Database.jfif'
 import Android from './assets/android.png'
 import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';


const Content = () => {
 
    return (
        <div>
             <section className="">
                 <h1>Most Popular Career</h1>
            <div className="site-content">
                <div className="post">
                   <div data-aos="slide-up" data-aos-delay="100">
                    <div className="post-content" >
                   
                        <div className="post-image">
                       
                         <div>
                         <NavLink to='/Blogs/Front-end' target="_blank">
                                <img src={frontEnd} style={{ width:850}} className="img" alt="blog1"/>
                           </NavLink> </div>
                          
                            <div className="post-info flex-row">
                                <span><AssignmentIndIcon/>&nbsp;&nbsp;Vivekanad Kumar</span>
                                <span><CalendarTodayIcon/>&nbsp;&nbsp;Jan 2021 </span>
                               
                            </div>
                        </div> 
                        <h3>Front-End Dev</h3>
                        <div className="post-title">
                            <NavLink to='/Blogs/Front-end' target="_blank"> A user interface is like a joke. If you have to explain it, it’s
                                not that good</NavLink>
                            <p>As business strategists and project managers scramble to create seamless user experiences (UX) and
                user interfaces (UI), front end web development teams have never  been more crucial than before.
                By constructing compelling front end interfaces and final products, businesses can better tap into the
            <i>psychology </i>of attracting consumers and future clients.
                </p>
                  <NavLink to='/Blogs/Front-end'>
                            <Button  className="btn post-btn">Read More &nbsp;< ArrowDropDownIcon/></Button>
                        </NavLink></div> 
                        </div> 
                    </div>
                    <hr/>
                    <div className="post-content" data-aos="slide-up" data-aos-delay="200">
                        <h3>Back-End Dev</h3>
                        <div className="post-image">
                            <div>
                            <NavLink to='/Blogs/Back-end' target="_blank">
                                <img src={backEnd} style={{width:850}}class="img" alt="blog1"/>
                           </NavLink> </div>
                            <div className="post-info flex-row">
                                <span><AssignmentIndIcon/>&nbsp;&nbsp;Mohit Kushwaha</span>
                                <span><CalendarTodayIcon/>&nbsp;&nbsp;Jan 2021 </span>
                               
                            </div> 
                        </div> 
                        <div className="post-title">
                            <NavLink to='/Blogs/Back-end'>If debugging is the process of removing software bugs, then programming must be
                                the process of putting them in</NavLink>
                            <p>The backend developer has a vital role in web applications' performance. In addition to handling the business
            logic, they also ensure the frontend's development work is integrated and well delivered according to the
            project's goals and vision.</p>
                             <NavLink to='/Blogs/Back-end'>
                            <Button className="btn post-btn">Read More &nbsp;< ArrowDropDownIcon/></Button>
                            </NavLink>
                        </div>

                    </div>
                    <hr/>
                    <div className="post-content" data-aos="slide-up" data-aos-delay="300">
                        <h3>Artificial Intelligence Dev</h3>
                        <div className="post-image">
                            <div>
                            <NavLink to='/Blogs/AI' target="_blank" >
                                <img src={Ai} style={{width:850, minWidth:500}}class="img" alt="blog1"/>
                           </NavLink> </div>
                            <div className="post-info flex-row">
                                <span><AssignmentIndIcon/>&nbsp;&nbsp;Krishan Kant</span>
                                <span><CalendarTodayIcon/>&nbsp;&nbsp;Jan 2021 </span>
                               
                            </div>
                        </div>
                        <div className="post-title">
                            <NavLink to='/Blogs/AI' >The coming era of Artificial Intelligence will not be the era of war, but be the
                                era of deep compassion, non-violence, and love.</NavLink>
                            <p>Lverything we love about civilization is a product of
                                    intelligence, so amplifying our human intelligence with artificial intelligence
                                    has&nbsp;the potential&nbsp;of helping civilization flourish like never before – as
                                    long as we manage to keep the technology beneficial.</p>
                            <NavLink to='/Blogs/AI'>
                            <Button className="btn post-btn">Read More &nbsp;< ArrowDropDownIcon/></Button>
                       </NavLink> </div>

                    </div>
                    <hr/>
                    <div className="post-content" data-aos="slide-up" data-aos-delay="300">
                        <h3>Full Stack Dev</h3>
                        <div className="post-image">
                            <div>
                            <NavLink to='/Blogs/Full Stack Developer' target="_blank">
                                <img src={full}style={{width:850}}class="img" alt="blog1"/>
                          </NavLink>  </div>
                            <div className="post-info flex-row">
                                <span><AssignmentIndIcon/>&nbsp;&nbsp;Nazir Hussain</span>
                                <span><CalendarTodayIcon/>&nbsp;&nbsp;Jan 2021 </span>
                               
                            </div>
                        </div>
                        <div className="post-title">
                            <NavLink to='/Blogs/Full Stack Developer'>One of my most productive days was throwing away 1000 lines of code.</NavLink>
                            <p>Today, the full stack developers are in high demand in the software development industry.
                            Full-stack developers understand all aspects of the development process including the front
                            end and back end sides of the application.</p>
                                <NavLink to='/Blogs/Full Stack Developer'>
                            <Button className="btn post-btn">Read More &nbsp;< ArrowDropDownIcon/></Button>
                       </NavLink>
                        </div>

                    </div>
                    <hr/>
        </div>
        <aside class="sidebar">
                    <div class="category">
                        <h2>Category</h2>
                        <ul class="category-list">
                        <NavLink to='/category/c' >  <li class="list-items"data-aos="fade-left" data-aos-delay="100">
                               C
                                <span></span>
                            </li></NavLink>
                            <NavLink to='/category/cpp'>
                            <li class="list-items"data-aos="fade-left" data-aos-delay="200">
                                C++
                                <span></span>
                            </li></NavLink>
                            <NavLink to='/category/python' >
                            <li class="list-items"data-aos="fade-left" data-aos-delay="300">
                                Python
                                <span></span>
                            </li></NavLink>
                            <li class="list-items"data-aos="fade-left" data-aos-delay="300">
                                <NavLink to='/category/java' >Java</NavLink>
                                <span></span>
                            </li>
                            <NavLink to='/category/Puzzels' >
                            <li class="list-items"data-aos="fade-left" data-aos-delay="300">
                                Puzzels
                                <span></span>
                            </li></NavLink>
                            <NavLink to='/category/Roadmaps for differnt carrers'>
                            <li class="list-items"data-aos="fade-left" data-aos-delay="300">
                                Career Roadmaps
                                <span></span>
                            </li>
                            </NavLink>
                        </ul>
                    </div>
                    <div class="popular-post">
                        <h2>Popular Post</h2>
                        <div class="post-content" data-aos="slide-up" data-aos-delay="200">
                             <h3>Data Scientist</h3>
                            <div class="post-image">
                                <div>
                                <NavLink to='/Blogs/Data Scientist'>
                                    <img src={DataScience} style={{ width:300}} class="img" alt="blog1"/>
                                </NavLink>
                                </div>
                                <div class="post-info flex-row">
                                    <span><AssignmentIndIcon/>&nbsp;&nbsp;Admin</span>
                                    <span><CalendarTodayIcon/>&nbsp;&nbsp;Jan 2021 </span>
                                   
                                </div>
                            </div>
                            <div class="post-title">
                                <NavLink to='/Blogs/Data Scientist'>Data really powers everything that we do.</NavLink>
                                
                            </div>
    
                        </div>
                        <div class="post-content" data-aos="slide-up" data-aos-delay="200">
                             <h3> Data Analyst</h3>
                            <div class="post-image">
                                <div>
                                <NavLink to='/Blogs/Data Analyst'>
                                    <img src={ DataAnal} style={{ width:300}} class="img" alt="blog1"/>
                                </NavLink>
                                </div>
                                <div class="post-info flex-row">
                                    <span><AssignmentIndIcon/>&nbsp;&nbsp;Admin</span>
                                    <span><CalendarTodayIcon/>&nbsp;&nbsp;Jan 2021 </span>
                                   
                                </div>
                            </div>
                            <div class="post-title">
                                <NavLink to='/Blogs/Data Analyst'>Big data is at the foundation of all of the megatrends that are happening today, from social to mobile to the cloud to gaming.</NavLink>
                                
                            </div>
    
                        </div>
                        <div class="post-content" data-aos="slide-up" data-aos-delay="200">
                             <h3> Android Developer</h3>
                            <div class="post-image">
                                <div>
                                <NavLink to='/Blogs/Android Developer'>
                                    <img src={ Android} style={{ width:300}} class="img" alt="blog1"/>
                                 </NavLink>
                                </div>
                                <div class="post-info flex-row">
                                    <span><AssignmentIndIcon/>&nbsp;&nbsp;Admin</span>
                                    <span><CalendarTodayIcon/>&nbsp;&nbsp;Jan 2021 </span>
                                   
                                </div>
                            </div>
                            <div class="post-title">
                                <NavLink to='/Blogs/Android Developer'>Big data is at the foundation of all of the megatrends that are happening today, from social to mobile to the cloud to gaming.</NavLink>
                                
                            </div>
    
                        </div>
                        <div class="post-content" data-aos="slide-up" data-aos-delay="200">
                             <h3>Blockchain Developer</h3>
                            <div class="post-image">
                                <div>
                                <NavLink to='/Blogs/Blockchain'>
                                    <img src={BloackChain} style={{ width:300}} class="img" alt="blog1"/>
                                </NavLink>
                                </div>
                                <div class="post-info flex-row">
                                    <span><AssignmentIndIcon/>&nbsp;&nbsp;Admin</span>
                                    <span><CalendarTodayIcon/>&nbsp;&nbsp;Jan 2021 </span>
                                   
                                </div>
                            </div>
                            <div class="post-title">
                            <NavLink to='/Blogs/Blockchain'>We have elected to put our money and faith in a mathematical framework that is free of politics and human error.</NavLink>
                                
                            </div>
    
                        </div>
                        <div class="post-content" data-aos="slide-up" data-aos-delay="200">
                             <h3>Computer Network Architect</h3>
                            <div class="post-image">
                                <div>
                                <NavLink to='/Blogs/Computer Network Architect'>
                                    <img src={network} style={{ width:300}} class="img" alt="blog1"/>
                                </NavLink>
                                </div>
                                <div class="post-info flex-row">
                                    <span><AssignmentIndIcon/>&nbsp;&nbsp;Admin</span>
                                    <span><CalendarTodayIcon/>&nbsp;&nbsp;Jan 2021 </span>
                                   
                                </div>
                            </div>
                            <div class="post-title">
                            <NavLink to='/Blogs/Computer Network Architect'>Designers think everything done by someone else is awful, and that they could do it better themselves, which explains why I designed my own living room carpet, I suppose.</NavLink>                             
                            </div>
                        <div class="post-content" data-aos="slide-up" data-aos-delay="200">
                             <h3> Database Administrator</h3>
                            <div class="post-image">
                                <div>
                                <NavLink to='/Blogs/Database Administrator'>
                                    <img src={Database} style={{ width:300}} class="img" alt="blog1"/>
                                </NavLink>
                                </div>
                                <div class="post-info flex-row">
                                    <span><AssignmentIndIcon/>&nbsp;&nbsp;Admin</span>
                                    <span><CalendarTodayIcon/>&nbsp;&nbsp;Jan 2021 </span>
                                   
                                </div>
                            </div>
                            <div class="post-title">
                                <NavLink to='/Blogs/Database Administrator'>I have noted that persons with bad judgment are most insistent that we do what they think best.</NavLink>                            
                            </div>
                        </div>
                        </div>
                    </div>
                    </aside>
        </div>


</section> 


<Footer/>
</div>
   )
}

export default Content
